import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject, Subscription, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { isDefined } from "../shared/helpers";
import { NotificationBarComponent } from "../shared/notification-bar";


@Injectable()
export class HttpErrorHandlerService implements OnDestroy {
  notificationBar: NotificationBarComponent | undefined;
  errorSubscription: Subscription;
  constructor(
    httpErrorNotifier: HttpErrorNotifier,
    private translateService: TranslateService
  ) {
    this.errorSubscription = httpErrorNotifier.httpError$.subscribe(() => this.showMessage());
  }

  ngOnDestroy(): void {
    this.errorSubscription.unsubscribe();
  }

  showMessage(): void {
    if (isDefined(this.notificationBar)) {
      const error = this.translateService.instant("app.http-request-error");
      this.notificationBar!.showErrorMessage(
        {
          text: error,
          dismissible: true
        }
      );
    }
  }
}
@Injectable()
export class HttpErrorNotifier implements OnDestroy {
  private httpErrorSubject = new Subject();
  httpError$ = this.httpErrorSubject.asObservable();
  ngOnDestroy(): void {
    this.httpErrorSubject.complete();
  }

  broadcastErrorEvent(): void {
    this.httpErrorSubject.next(true);
  }
}

@Injectable()
export class HttpResponse5xErrorInterceptor implements HttpInterceptor {
  constructor(private httpErrorNotifier: HttpErrorNotifier) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(httpErrorResponse => {
        const err = httpErrorResponse as HttpErrorResponse;
        if (err.status >= 500 || err.status == 0) {
          this.httpErrorNotifier.broadcastErrorEvent();
        }
        return throwError(() => httpErrorResponse);
      })
    );
  }
}


